/**
 * The coverage basis as a person reads it (#1238). The API's `basis` is the agreement's note line, word for word, and
 * some sources append the model and field it came from, e.g. `"Hosted phone support included" (AccountContract.notes)`.
 * That suffix is an internal name, so the screen drops it and says where the line came from in plain words. The API
 * contract is untouched; this is a renderer.
 */
const MODEL_FIELD_SUFFIX = /\s*\(\s*[A-Za-z][A-Za-z0-9]*\.[A-Za-z_][A-Za-z0-9_]*\s*\)\s*$/

export const AGREEMENT_NOTES_SOURCE = 'from the agreement notes'

export function coverageBasisText(basis: string): string {
  const stripped = basis.replace(MODEL_FIELD_SUFFIX, '')
  if (stripped === basis) return basis
  return stripped.trim() ? `${stripped.trim()} (${AGREEMENT_NOTES_SOURCE})` : AGREEMENT_NOTES_SOURCE
}
